import React from 'react';
import NavbarComponent from "./Navbar.js";
import { Link } from "react-router-dom";
import RegisterComponent from "./RegisterForm.js";
class About extends React.Component {
    render() {
        return (
          <div>
            <header className="page-header">
              <NavbarComponent></NavbarComponent>
            </header>

            <div
              style={{
                paddingLeft: "0",
                background: " linear-gradient(to bottom, #f2d7d9, #f9e7e9, #ffffff)", // Gradient background similar to sidebar
                minHeight: "83.7vh", // Ensures the background covers the full height
              }}
            >
              <RegisterComponent></RegisterComponent>
            </div>
            <footer id="footer">
                <div className="container">
                    <div className="copyright">
                        &copy; Copyright <strong><span>EverFound</span></strong>. All Rights Reserved
                    </div>
                    <div className="credits">
                        Designed by <a href="/">EverFound</a>
                    </div>
                </div>
            </footer>
          </div>
        );
    }
}

export default About;